import { Link } from "@tanstack/react-router";
import { Button, Card, CardContent, CardDescription, CardHeader, CardTitle } from "@clones/ui";

export function NotFoundPage() {
  return (
    <div className="grid min-h-screen place-items-center bg-background p-4">
      <Card className="w-full max-w-md text-center">
        <CardHeader>
          <CardTitle>Страница не найдена</CardTitle>
          <CardDescription>Похоже, такой страницы нет.</CardDescription>
        </CardHeader>
        <CardContent>
          <Button asChild className="w-full">
            <Link to="/">На главную</Link>
          </Button>
        </CardContent>
      </Card>
    </div>
  );
}
